// base64url → base64 with padding so `atob` can decode it. Returns null on malformed input so callers can choose how to react.
export const decodeJwtPayload = <T = Record<string, unknown>>(token: string): T | null => {
  const [, payloadPart] = token.split('.')
  if (!payloadPart) return null
  try {
    const base64 = payloadPart.replace(/-/g, '+').replace(/_/g, '/')
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4)
    return JSON.parse(atob(padded)) as T
  } catch {
    return null
  }
}
